// TeamMembers.js
import React from 'react';
import TeamMember from './TeamMember';
import './TeamMembers.css';
import {teamData} from './teamData';
import Seo from '../components/Seo';
import { useI18n } from '../i18n/I18nContext';

const teamMembers = [...teamData];
const ziruiIndex = teamMembers.findIndex((member) => member.id === 8);
if (ziruiIndex > 1) {
  const [zirui] = teamMembers.splice(ziruiIndex, 1);
  teamMembers.splice(1, 0, zirui);
}

const TeamMembers = () => {
  const { t } = useI18n();

  return (
    <div className="team-members">
      <Seo
        title={t('team.seoTitle')}
        description={t('team.seoDescription')}
        path="/team"
      />
      <h1 className="team-title">{t('team.title')}</h1>
      {teamMembers.map((member) => (
        <TeamMember key={member.id} {...member} />
      ))}
    </div>
  );
};

export default TeamMembers;
